exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-style{color:#292f4c!important;background-color:#fff!important;padding:5px 10px!important;border-radius:5px!important;margin-right:8px!important;margin-bottom:8px!important}.custom-style,.custom-style:hover{box-shadow:0 0 10px rgba(61,61,61,.24)}.custom-style:hover{background:linear-gradient(90deg,#262f4c 35%,#8b8b8b);color:#fff!important}", ""]);

// exports
